import 'src/styles/ui/button-row.css';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * A row of equal-width children (e.g. Yes / No or Back / Next buttons): a flex
 * row where every direct child grows to fill the width evenly. Generic — usable
 * by any feature.
 */
const ButtonRow = ({ children, className, ...props }) => (
  <div className={classNames('button-row', className)} {...props}>
    {children}
  </div>
);

ButtonRow.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

ButtonRow.defaultProps = { children: null, className: '' };

export default ButtonRow;
